export const getLanguage = (className: string) => {
  if (className.includes('javascript')) return 'javascript'
  if (className.includes('.js')) return 'js'
  if (className.includes('.tsx')) return 'tsx'
  if (className.includes('.ts')) return 'ts'
  if (className.includes('.jsx')) return 'jsx'
  if (className.includes('graphql')) return 'graphql'
  if (className.includes('gql')) return 'gql'
  if (className.includes('css')) return 'css'
  if (className.includes('json')) return 'json'
  if (className.includes('sass')) return 'sass'
  if (className.includes('yml')) return 'yml'
  if (className.includes('yaml')) return 'yaml'
  if (className.includes('bash')) return 'bash'
  if (className.includes('python')) return 'python'
  if (className.includes('python')) return 'py'
  if (className.includes('docker')) return 'docker'
  if (className.includes('dockerfile')) return 'dockerfile'
  if (className.includes('Dockerfile')) return 'dockerfile'
  return ''
}
